import React from 'react';
// import { DownOutlined } from '@ant-design/icons';
import ScrollElement from 'rc-scroll-anim/lib/ScrollElement';
import QueueAnim from 'rc-queue-anim';
import { TweenOneGroup } from 'rc-tween-one';
import BannerAnim, { Element } from 'rc-banner-anim';
import 'rc-banner-anim/assets/index.css';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

const { BgElement } = Element;
const Banner = (props) => {
  const { dataSource, ...restProps } = props;
  const { t } = useTranslation();
  const { titleWrapper, page, block } = dataSource;

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <Row>
          <Col xl={12} md={24}>
            <img src={require('@/assets/production/basic/basic-10.png')} style={{ width: '100%' }} />
          </Col>
          <Col xl={12} md={24}>
            <div {...titleWrapper}>
              <h1 {...titleWrapper.children[0]}>
                {t(titleWrapper.children[0].children)}
              </h1>
              <h2 {...titleWrapper.children[1]}>
                {titleWrapper.children[1].children}
              </h2>
              <div {...titleWrapper.children[2]} >
                <div dangerouslySetInnerHTML={{ __html: t(titleWrapper.children[2].children) }}></div>
              </div>
            </div>
          </Col></Row>
      </div>
    </div>
  );
};

export default Banner;
